import { Check } from "lucide-react";
import { steps } from "../data";
import { useConfiguratorStore } from "../store";

export function StepNavigation() {
  const current = useConfiguratorStore((state) => state.step);
  const setStep = useConfiguratorStore((state) => state.setStep);
  const currentIndex = steps.findIndex((item) => item.id === current);

  return (
    <nav className="step-navigation" aria-label="Konfigurationstrin">
      <div className="step-title">
        <span>Konfigurator</span>
        <strong>{steps[currentIndex].label}</strong>
      </div>
      <ol>
        {steps.map((step, index) => {
          const isCurrent = step.id === current;
          const isComplete = index < currentIndex;
          return (
            <li key={step.id}>
              <button
                type="button"
                className={isCurrent ? "current" : isComplete ? "complete" : ""}
                onClick={() => setStep(step.id)}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span className="step-number">
                  {isComplete ? <Check size={12} strokeWidth={2.5} /> : index + 1}
                </span>
                <span className="step-label">{step.label}</span>
                <span className="step-short">{step.shortLabel}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
